/**
 * Browser shim for extend
 * Some dependencies import extend which is a Node.js deep merge utility.
 * This shim provides a compatible implementation for the browser.
 */

type ExtendTarget = Record<string, unknown>;

/**
 * Deep extend/merge objects
 * @param deep - If true, perform deep merge; if object, it's the first source
 * @param target - Target object to extend
 * @param sources - Source objects to merge from
 */
function extend(deep: boolean | ExtendTarget, ...args: ExtendTarget[]): ExtendTarget {
  let target: ExtendTarget;
  let sources: ExtendTarget[];
  let isDeep = false;

  if (typeof deep === 'boolean') {
    isDeep = deep;
    target = args[0] || {};
    sources = args.slice(1);
  } else {
    target = deep || {};
    sources = args;
  }

  for (const source of sources) {
    if (source == null) continue;

    for (const key of Object.keys(source)) {
      const sourceVal = source[key];
      const targetVal = target[key];

      if (isDeep && sourceVal && typeof sourceVal === 'object' && !Array.isArray(sourceVal)) {
        target[key] = extend(
          true,
          (targetVal && typeof targetVal === 'object' ? targetVal : {}) as ExtendTarget,
          sourceVal as ExtendTarget
        );
      } else {
        target[key] = sourceVal;
      }
    }
  }

  return target;
}

export default extend;
export { extend };
